/**
 * Fotografia dos campos de formulário dentro de `raiz` (valores, marcados, interruptores).
 * Só conta o que está dentro de um `<form>` — campos de busca soltos não disparam o aviso de
 * "Sair sem salvar?" — e ignora o que estiver dentro de `[data-sem-protecao]`.
 * Comparar a fotografia do primeiro toque/tecla com a atual diz se a pessoa mudou algo.
 */
export function fotografarFormulario(raiz: HTMLElement | null): string {
  if (!raiz) return "";
  const partes: string[] = [];
  raiz
    .querySelectorAll<HTMLElement>(
      "form input, form textarea, form select, form [role='switch'], form [aria-pressed]",
    )
    .forEach((el) => {
      if (el.closest("[data-sem-protecao]")) return;
      if (el instanceof HTMLInputElement) {
        if (el.type === "hidden" || el.type === "search" || el.type === "submit") return;
        if (el.type === "checkbox" || el.type === "radio") partes.push(el.checked ? "1" : "0");
        else if (el.type === "file") partes.push(String(el.files?.length ?? 0));
        else partes.push(el.value);
      } else if (el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement) {
        partes.push(el.value);
      } else {
        partes.push(el.getAttribute("aria-checked") ?? el.getAttribute("aria-pressed") ?? "");
      }
    });
  return JSON.stringify(partes);
}
